import { Box, Divider, Text } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency from 'modules/core/lib/money'

interface CurrentOrEstimatedProfitTooltipMessageProps {
  currency: string
  plannedCosts: number
  plannedIncome: number
  registeredCosts: number
}

const CurrentOrEstimatedProfitTooltipMessage = ({
  currency,
  plannedCosts,
  plannedIncome,
  registeredCosts,
}: CurrentOrEstimatedProfitTooltipMessageProps) => {
  const {
    access: { locale },
  } = useCurrentSession()

  return (
    <>
      <Box alignItems="flexStart">
        <Text size="200" color="grey000White" weight="semibold">
          {i18n
            .t(
              'project_management.overview.sections.financial_details.insights.revenue_to_date.tooltip_message.profit'
            )
            .toUpperCase()}
        </Text>
      </Box>

      <Box paddingY="s12" gap="s4">
        <Box flexDirection="row" justifyContent="spaceBetween">
          <Text size="300" color="grey000White" weight="medium">
            {i18n.t(
              'project_management.overview.sections.financial_details.insights.current_profit.title'
            )}
          </Text>
          <Text size="300" color="grey000White" weight="medium">
            {MoneyWithCurrency({ amount: plannedIncome - registeredCosts, currency, locale })}
          </Text>
        </Box>
        <Box flexDirection="row" justifyContent="spaceBetween">
          <Text size="200" color="grey000White" weight="normal">
            {i18n.t(
              'project_management.overview.sections.financial_details.insights.revenue_to_date.tooltip_message.planned_income'
            )}
          </Text>
          <Text size="200" color="grey000White" weight="normal">
            {MoneyWithCurrency({ amount: plannedIncome, currency, locale })}
          </Text>
        </Box>
        <Box flexDirection="row" justifyContent="spaceBetween">
          <Text size="200" color="grey000White" weight="normal">
            {i18n.t(
              'project_management.overview.sections.financial_details.insights.current_profit.current_cost'
            )}
          </Text>
          <Text size="200" color="grey000White" weight="normal">
            {MoneyWithCurrency({ amount: registeredCosts, currency, locale })}
          </Text>
        </Box>
      </Box>
      {!!plannedCosts && <Divider backgroundColor="#FFFFFF" />}
      {!!plannedCosts && (
        <Box paddingTop="s12" gap="s4">
          <Box flexDirection="row" justifyContent="spaceBetween">
            <Text size="300" color="grey000White" weight="medium">
              {i18n.t(
                'project_management.overview.sections.financial_details.insights.revenue_to_date.tooltip_message.estimated_profit'
              )}
            </Text>
            <Text size="300" color="grey000White" weight="medium">
              {MoneyWithCurrency({ amount: plannedIncome - plannedCosts, currency, locale })}
            </Text>
          </Box>
          <Box flexDirection="row" justifyContent="spaceBetween">
            <Text size="200" color="grey000White" weight="normal">
              {i18n.t(
                'project_management.overview.sections.financial_details.insights.revenue_to_date.tooltip_message.planned_income'
              )}
            </Text>
            <Text size="200" color="grey000White" weight="normal">
              {MoneyWithCurrency({ amount: plannedIncome, currency, locale })}
            </Text>
          </Box>
          <Box flexDirection="row" justifyContent="spaceBetween">
            <Text size="200" color="grey000White" weight="normal">
              {i18n.t(
                'project_management.overview.sections.financial_details.insights.revenue_to_date.tooltip_message.planned_costs'
              )}
            </Text>
            <Text size="200" color="grey000White" weight="normal">
              {MoneyWithCurrency({ amount: plannedCosts, currency, locale })}
            </Text>
          </Box>
        </Box>
      )}
    </>
  )
}

export default CurrentOrEstimatedProfitTooltipMessage
